import PropTypes from 'prop-types';

import AwardModel from './Award';

export default {
  award: PropTypes.shape(AwardModel).isRequired,
  count: PropTypes.number.isRequired,
}
